import React from 'react';
import styles from './icon.module.scss';
import { ReactComponent as Desalination } from '../../svg/desalination.svg';
import { ReactComponent as Groundwater } from '../../svg/ground-water.svg';
import { ReactComponent as GroundwaterReplenishment } from '../../svg/ground-water-replenishment.svg';
import { ReactComponent as Dam } from '../../svg/dam.svg';
import { ReactComponent as RecycleIrrigation } from '../../svg/recycle-irrigation.svg';
import { ReactComponent as RecycleIndustry } from '../../svg/recycle-industry.svg';
import { ReactComponent as OceanOutfall } from '../../svg/ocean-outfall.svg';

interface Props {
  type: string;
  label: string;
  className?: string;
}

export const Icon: React.FC<Props> = ({ label, type, className }) => {
  let IconType: React.FC;
  let iconColor;

  switch (type) {
    case 'desalination':
      IconType = Desalination;
      iconColor = 'pink';
      break;
    case 'groundwater':
      IconType = Groundwater;
      iconColor = 'green';
      break;
    case 'dam':
      IconType = Dam;
      iconColor = 'blue';
      break;
    case 'groundwater-replenishment':
      IconType = GroundwaterReplenishment;
      iconColor = 'orange';
      break;
    case 'recycle-irrigation':
      IconType = RecycleIrrigation;
      iconColor = 'green';
      break;
    case 'recycle-industry':
      IconType = RecycleIndustry;
      iconColor = 'pink';
      break;
    case 'ocean-outfall':
      IconType = OceanOutfall;
      iconColor = 'blue';
      break;
    default:
      IconType = Desalination;
      iconColor = 'pink';
      break;
  }

  return (
    <span
      className={`${styles.icon} ${className}`}
      style={{ backgroundColor: styles[iconColor] }}
      aria-label={label}
      role="img"
    >
      <IconType />
    </span>
  );
};
